export default __webpack_public_path__ + "static/globe-green-14ba1ee89949153013ac1e351fd88bb3.svg";